<template>
  <div class="afdc-row">
    <div class="afdc-col-md-6">
      <div class="afdc-row afdc-no-gutters">
        <div class="afdc-col-md-6 afdc-location-inputs-col">
          <div class="afdc-form-group">
            <label class="afdc-sr-only" for="afdc-start">{{ $t("Start location") }}</label>
            <input v-model="queryStartLive" v-on:change="triggerQueryStartChange" type="text" :class="{'afdc-form-control':true, 'afdc-clearable-input':true, 'afdc-start-location':!isMobileView}" id="afdc-start" v-bind:placeholder="$t('Start location')">

            <div v-if="queryStartLive" :class="{'afdc-clear-input':true, 'afdc-clear-start-location':true, 'afdc-mobile-clear':isMobileView}" v-on:click="clearStart">
              <span class="afdc-sr-only">{{ $t('Clear start location') }}</span>
              <font-awesome-icon icon="times-circle" class="afdc-fa-icon"/>
            </div>
          </div>

          <div class="afdc-form-group">
            <label class="afdc-sr-only" for="afdc-end">{{ $t("End location") }}</label>
            <div class="afdc-input-group">
              <input v-model="queryEndLive" v-on:change="triggerQueryEndChange" type="text" class="afdc-form-control afdc-clearable-input" id="afdc-end" v-bind:placeholder="$t('End location')">

              <div v-if="queryEndLive" :class="{'afdc-clear-input':true, 'afdc-mobile-clear':isMobileView}" v-on:click="clearEnd">
                <span class="afdc-sr-only">{{ $t('Clear end location') }}</span>
                <font-awesome-icon icon="times-circle" class="afdc-fa-icon"/>
              </div>

              <div class="afdc-input-group-append" v-if="!isMobileView">
                <button class="afdc-btn afdc-btn-secondary" type="submit" v-bind:aria-label="$t('Search')"><font-awesome-icon icon="search" class="afdc-fa-icon"/></button>
              </div>
            </div>
          </div>
        </div>

        <div class="afdc-col-md-6">
          <find-fuel-filter/>
        </div>
      </div>

      <div class="afdc-row">
        <div class="afdc-col-md-12">
          <div class="afdc-form-group afdc-form-inline afdc-distance-input">
            <label class="afdc-sr-only" for="afdc-distance">{{ $t("Distance from the Route to Show Stations") }}</label>
            <div class="afdc-distance-text">
              <span>{{ $t("Show stations within") }}</span>
              <input v-model.lazy="queryDistance" type="text" class="afdc-form-control afdc-form-control-sm">
              <select v-model="queryDistanceUnit" class="afdc-custom-select afdc-custom-select-sm">
                <option v-for="option in distanceUnitOptions" v-bind:key="option.key" v-bind:value="option.key">
                  {{ option.name }}
                </option>
              </select>
              <span>{{ $t(" of the route") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="afdc-col-md-6">
      <div class="afdc-row afdc-h-100">
        <div class="afdc-col-md">
          <find-fuel-specific-filters/>
        </div>

        <div class="afdc-col-md-auto" v-if="!isMobileView">
          <router-link v-bind:to="{ name: 'FindNearestStations' }" event="" v-on:click.native.prevent="clickToggleMode('toggle')" class="afdc-switch-find-type">
            <div id="afdc-switch-find-type">
              <font-awesome-icon icon="search" class="afdc-fa-icon"/>
              <div id="afdc-switch-find-type-text">{{ $t('Find Stations') }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FindFuelFilter from '@/components/FindFuelFilter.vue';
import FindFuelSpecificFilters from '@/components/FindFuelSpecificFilters.vue';
import FindMixin from '@/lib/FindMixin';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  mixins: [
    FindMixin,
  ],

  components: {
    FindFuelFilter,
    FindFuelSpecificFilters,
  },

  data() {
    return {
      queryStartLive: null,
      queryEndLive: null,
    };
  },

  computed: {
    distanceUnitOptions() {
      return this.$store.getters.loaderDistanceUnits;
    },

    queryStart: syncInputRouteQuery('start'),
    queryEnd: syncInputRouteQuery('end'),
    queryDistance: syncInputRouteQuery('distance'),
    queryDistanceUnit: syncInputRouteQuery('distance_unit'),

    isMobileView() {
      return this.$store.getters.isMobileView;
    },
  },

  watch: {
    queryStart: {
      immediate: true,
      handler: 'setQueryStartLive',
    },

    queryEnd: {
      immediate: true,
      handler: 'setQueryEndLive',
    },
  },

  methods: {
    // Have a "live" version of the location inputs (updated on every
    // keystroke), but only sync it with the query params on "change" events
    // (similar to Vue's normal "lazy" model syncing). This allows us to have
    // the live version (unlike Vue's lazy handling), which we can use for
    // determining whether the "x" should be shown, but still defer submission
    // until the actual change event (so we're not searching on every
    // keystroke).
    setQueryStartLive() {
      if (this.queryStart !== this.queryStartLive) {
        this.queryStartLive = this.queryStart;
      }
    },
    triggerQueryStartChange() {
      this.queryStart = this.queryStartLive;
    },

    setQueryEndLive() {
      if (this.queryEnd !== this.queryEndLive) {
        this.queryEndLive = this.queryEnd;
      }
    },
    triggerQueryEndChange() {
      this.queryEnd = this.queryEndLive;
    },

    clearStart() {
      this.queryStart = null;
    },

    clearEnd() {
      this.queryEnd = null;
    },
  },
};
</script>

<style lang="scss">
.start-location {
  width: calc(100% - 40px);
}

.distance-input {
  span {
    display: inline-block;
    vertical-align: middle;
  }

  .form-control {
    display: inline-block;
  }

  .custom-select {
    width: auto;
  }

  input.form-control {
    width: 55px;
    text-align: center;
  }
}
</style>
